import React, {useState} from "react";
import { Link } from "react-router-dom";
import BannerImage from "../../assets/images/bussiness.jpg"; // replace with your image
import SignInModal from "../Modals/signInModal";               // adjust path

const HomeBanner = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [activeModal, setActiveModal] = useState(null);
    return (
        <>
            <section className="bg-[#D9F4EF] pt-[90px] pb-[80px]">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

                        {/* LEFT CONTENT */}
                        <div>
                            {/* Badge */}
                            <span className="inline-block mb-4 px-4 py-1 text-sm rounded-full bg-white text-gray-600">
                                Smart Invoice Finance
                            </span>

                            {/* Heading */}
                            <h1 className="text-[40px] leading-[1.15] font-semibold text-[#111827] mb-6">
                                Turn outstanding invoices
                                <br />
                                into instant working
                                <br />
                                capital.
                            </h1>

                            {/* Description */}
                            <p className="text-gray-600 max-w-xl mb-8">
                                Invexflow provides flexible invoice discounting so your business
                                can access cash tied up in receivables within 24–48 hours—without
                                disrupting customer relationships.
                            </p>

                            {/* CTA Buttons */}
                            <div className="flex flex-wrap items-center gap-4 mb-10">
                                <button onClick={() => {
                                    setActiveModal("signin");
                                    setMobileOpen(false);
                                }} className="bg-[#0FB9B1] hover:bg-[#0da39c] transition text-white px-6 py-3 rounded-lg font-medium">
                                    Start a Free Assessment
                                </button>
                                <Link
                                    to="/contact" className="bg-white border px-6 py-3 rounded-lg font-medium hover:bg-gray-50">
                                    Talk to an Expert
                                </Link>
                            </div>

                            {/* Feature Cards */}
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
                                <Feature
                                    title="Transparent Pricing"
                                    desc="No hidden fees. One clear discount rate based on risk and tenure."
                                />
                                <Feature
                                    title="Fast Decisions"
                                    desc="Automated checks and same-day decisions for eligible invoices."
                                />
                                <Feature
                                    title="Control & Flexibility"
                                    desc="Choose which invoices to discount and how often. No long-term lock-ins."
                                />
                            </div>
                        </div>

                        {/* RIGHT CARD */}
                        <div className="flex justify-center">
                            <div className="bg-white rounded-xl shadow-lg w-full max-w-xl overflow-hidden">

                                {/* Stats */}
                                {/* <div className="p-5 space-y-3 border-b">
                                    <Stat label="Eligible invoice" value="PKR 120,000" />
                                    <Stat label="Advance rate" value="up to 90%" />
                                    <Stat label="Funds in" value="24–48 hrs" />
                                    <Stat label="Typical cost" value="1.0–2.2% / 30 days" />
                                </div> */}

                                {/* Image */}
                                <div className="p-4">
                                    <img
                                        src={BannerImage}
                                        alt="Business discussion"
                                        className="rounded-lg w-full object-cover"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {activeModal === "signin" && (
                <SignInModal
                    onClose={() => setActiveModal(null)}
                    onSwitchToSignUp={() => setActiveModal("signup")}
                />
            )}
        </>
    );
};

export default HomeBanner;

/* ---------- Sub Components ---------- */

const Feature = ({ title, desc }) => (
    <div className="bg-white rounded-xl p-4 text-center">
        <h4 className="font-semibold text-sm text-[#111827] mb-1">{title}</h4>
        <p className="text-xs text-gray-600">{desc}</p>
    </div>
);

const Stat = ({ label, value }) => (
    <div className="flex items-center justify-between border border-dashed rounded-lg px-4 py-2">
        <span className="text-sm text-gray-500">{label}</span>
        <span className="font-semibold text-[#111827]">{value}</span>
    </div>
);
